import { render } from "./ArrowInSquareIcon.vue?vue&type=template&id=2013f5f3&scoped=true"
import script from "./ArrowInSquareIcon.vue?vue&type=script&lang=js"
export * from "./ArrowInSquareIcon.vue?vue&type=script&lang=js"

import "./ArrowInSquareIcon.vue?vue&type=style&index=0&id=2013f5f3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2013f5f3"

export default script